import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import BaseStore from '../base/store';
import PropertySearchStore from './index';

export default new Vuex.Store(Object.assign(
    {},
    BaseStore,
    { 
        strict: process.env.NODE_ENV !== 'production',
        modules: { 
            'propertySearchStore': PropertySearchStore
        } 
    }
));